import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../leap.css"
import { config } from "../../../configs/leap"
import loaderSvg from "../../../images/leap-loading.svg";

const brand =  {
    value: "leap",
    id: 5,
    division : "5",
    name : "Leapmotor"
};

function LeapApp(props){
    return (
        <App brand={brand} formName={"fca-leap-ratd"} config={config} loader={loaderSvg} models={config.models}/>
    )
}

ReactDOM.render(<LeapApp/>,document.getElementById("root"));
